// Components
import dayjs from 'dayjs';
// Types
import type { IRangeValue } from 'types/dateTime.type';
import { TEInput } from '@timeedit/ui-components';
import {
  Checkbox,
  DatePicker,
  Space,
  Spin,
} from '@timeedit/ui-components/antd';

interface ICheckableDateRangeProps {
  label: string;
  tooltip: string;
  flow?: 'row' | 'column';
  value: IRangeValue;
  onChange: (value: IRangeValue) => void;
  disabled?: boolean;
  loading?: boolean;
  dataTestId?: string;
  allowEmpty?: boolean;
  status?: 'error' | 'warning';
}

const CheckableDateRange = ({
  label,
  tooltip,
  flow = 'row',
  value,
  onChange,
  disabled = false,
  loading = false,
  dataTestId,
  allowEmpty,
  status,
}: ICheckableDateRangeProps) => {
  const isChecked =
    allowEmpty || (!!value && (value[0] !== null || value[1] !== null));
  return (
    <TEInput.LabelWrapper label={label} tooltip={tooltip} flow={flow}>
      <Space data-testid={dataTestId}>
        {!allowEmpty && (
          <Checkbox
            checked={isChecked}
            onChange={(e) =>
              onChange(
                e.target.checked
                  ? [dayjs().startOf('day'), dayjs().endOf('day')]
                  : [null, null]
              )
            }
            disabled={disabled || loading}
            data-testid="date-range-enable"
          ></Checkbox>
        )}
        <Spin spinning={loading} size="small" data-testid="date-range-loading">
          <DatePicker.RangePicker
            size="small"
            value={value}
            status={status}
            allowEmpty={allowEmpty ? [true, true] : [false, false]}
            disabled={!isChecked || disabled || loading}
            onChange={onChange}
            data-testid="date-range"
          />
        </Spin>
      </Space>
    </TEInput.LabelWrapper>
  );
};

export default CheckableDateRange;
